import { MapMarkerWithPopup, useTheme } from "@shared/primitive-components"
import { FeatureGroup, Polyline, TileLayer, Tooltip, useMap } from "react-leaflet"
import { Theme } from "../theme/theme.types"
import { type Feature, type GeoJson, type LineString, type LineStringFeatureProperties } from "./types"
import { isSpeedUnreliable, swapLatLng } from "./utils"

type Props = {
  route: GeoJson
  styleFn: (geoJsonFeature: Feature<LineString, LineStringFeatureProperties>, theme: Theme) => string
  generateTooltipContentFn: (
    geoJsonFeature: Feature<LineString, LineStringFeatureProperties>,
    hasUnreliableSpeed: boolean
  ) => JSX.Element
  apiKey: string
}

export const MapContentRaw = ({ route, styleFn, generateTooltipContentFn, apiKey }: Props) => {
  const theme = useTheme()
  const map = useMap()
  map.attributionControl.setPrefix(false)
  map.setMaxBounds(map.getBounds())
  map.setMinZoom(map.getZoom())

  const here = { apiKey }
  const hereTileUrl = `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png8?style=lite.night&apiKey=${here.apiKey}`
  const attribution = `&copy; HERE 2022`

  return (
    <>
      <TileLayer url={hereTileUrl} attribution={attribution} />
      {route.lineStrings.map((feature, i) => (
        // Duplicates on the geojson features makes mandatory to use the index as a key
        // eslint-disable-next-line react/no-array-index-key
        <FeatureGroup key={i}>
          <Tooltip sticky>{generateTooltipContentFn(feature, isSpeedUnreliable(feature))}</Tooltip>
          <Polyline
            color={styleFn(feature, theme)}
            weight={5}
            positions={feature.geometry.coordinates.map((pos) => swapLatLng(pos))}
          />
        </FeatureGroup>
      ))}
      {route.points.map((point, i) => (
        <MapMarkerWithPopup
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          position={swapLatLng(point.geometry.coordinates)}
          content={`
            Speed Mph: ${point.properties.speedMph},
            Timestamp: ${point.properties.timestamp}`}
        />
      ))}
    </>
  )
}
